export default "__VITE_ASSET__B9_gEP4G__"